import { Injectable } from '@angular/core';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
import firebase from 'firebase/app';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import {  AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, combineLatest } from 'rxjs';
import {count, flatMap, map} from 'rxjs/operators';
import { resolveDefinition } from '@angular/core/src/view/util';
import {User} from '../models/user.model';
import {Contact} from '../models/contact.model';
import {ContactListDTO} from '../models/contactlistdto.model';
@Injectable()
export class AdfListService {

  public  userRole: any;
  public deleted_access:any;
  public allopenadf :any;
  public allclosedadf:any;

   userCollection: AngularFirestoreCollection<User>;
   contactItem: Observable<ContactListDTO[]>;
  
  constructor(
    public db: AngularFirestore,
  ) { 
   // this.collectionInitialization();
  }

  getAllAdfList(limit:any ='', offset:any ='',broker_reference:any ='') {
    debugger;
    let total_data = limit * offset;

    if(limit !== '' && offset!==''){
      
        return new Promise(function (resolve, reject) {

          if(broker_reference == '') {
            firebase.firestore().collection("adf_forms").where('deleted', '==', 0).orderBy('created_date', 'desc').limit(total_data).get()
            .then(function (querySnapshot2) {
              console.log(querySnapshot2);
              let adflist = [];
              querySnapshot2.forEach(function (adfDoc) {
                console.log(adfDoc.data());
                 let adf_data = adfDoc.data();
              //   contact_data.uid = contDoc.id;
                 adflist.push(adf_data)
              })
              //console.log(employmentlist);
             // this.contactItem = userlist;
              resolve(adflist)
            })
          }
          else {
            firebase.firestore().collection("adf_forms").where('deleted', '==', 0).where('reference_broker', 'in', broker_reference).orderBy('created_date', 'desc').limit(total_data).get()
            .then(function (querySnapshot2) {
              console.log(querySnapshot2);
              let adflist = [];
              querySnapshot2.forEach(function (adfDoc) {
                console.log(adfDoc.data());
                 let adf_data = adfDoc.data();
              //   contact_data.uid = contDoc.id;
                 adflist.push(adf_data)
              })
              //console.log(employmentlist);
             // this.contactItem = userlist;
              resolve(adflist)
            })
          }
           
          })
          .then((adflist:any)=>{
            console.log(adflist);
            let users_finlist= []
            return new Promise((resolve,reject)=>{
              const requests = adflist.map(function(userdata){
    
                const promise = new Promise(function (resolve, reject) {
                  console.log(userdata.reference_broker);
                  if(userdata.reference_broker) {
                    firebase.firestore().collection("users").doc(userdata.reference_broker).get().then(function (brokersnap) {
                      //console.log('abc');
                        userdata.broker_data = brokersnap.data();
                        users_finlist.push(userdata);
                        resolve(true);
                      })
                  }
                  else {
                    userdata.broker_data = null;
                    users_finlist.push(userdata);
                    resolve(true);
                  }
                  
                })
                return promise;
              })
      
              Promise.all(requests).then(function (result) {
                console.log('all promiseall')
                resolve(users_finlist)
              })
            })
            
          });
    }
    else{
          return new Promise(function (resolve, reject) {
            if(broker_reference == '') {
              firebase.firestore().collection("adf_forms").where('deleted', '==', 0).orderBy('created_date', 'desc').get()
              .then(function (querySnapshot2) {
                console.log(querySnapshot2);
                let adflist = [];
                querySnapshot2.forEach(function (adfDoc) {
                  console.log(adfDoc.data());
                  let adf_data = adfDoc.data();
                //   contact_data.uid = contDoc.id;
                  adflist.push(adf_data)
                })
                //console.log(employmentlist);
              // this.contactItem = userlist;
                resolve(adflist)
              })
            }
            else {
              firebase.firestore().collection("adf_forms").where('deleted', '==', 0).where('reference_broker', 'in', broker_reference).orderBy('created_date', 'desc').get()
              .then(function (querySnapshot2) {
                console.log(querySnapshot2);
                let adflist = [];
                querySnapshot2.forEach(function (adfDoc) {
                  console.log(adfDoc.data());
                  let adf_data = adfDoc.data();
                //   contact_data.uid = contDoc.id;
                  adflist.push(adf_data)
                })
                //console.log(employmentlist);
              // this.contactItem = userlist;
                resolve(adflist)
              })
            }
            
          })
          .then((adflist:any)=>{
            console.log(adflist);
            let users_finlist= []
            return new Promise((resolve,reject)=>{
              const requests = adflist.map(function(userdata){
    
                const promise = new Promise(function (resolve, reject) {
                  console.log(userdata.reference_broker);
                  if(userdata.reference_broker) {
                    firebase.firestore().collection("users").doc(userdata.reference_broker).get().then(function (brokersnap) {
                      //console.log('abc');
                        userdata.broker_data = brokersnap.data(); 
                        users_finlist.push(userdata);
                        resolve(true);
                      })
                  }
                  else {
                    userdata.broker_data = null;
                    users_finlist.push(userdata);
                    resolve(true);
                  }
                  
                })
                return promise;
              })
      
              Promise.all(requests).then(function (result) {
                console.log('all promiseall')
                resolve(users_finlist)
              })
            })
            
          });
    }

  }


  getAllAdfsform() {
    return new Promise((resolve,reject) => {
      firebase.firestore().collection("adf_forms").where('deleted', '==', 0).orderBy('created_date', 'desc').get()
            .then(function (querySnapshot2) {
              console.log(querySnapshot2);
              let adflist = [];
              querySnapshot2.forEach(function (adfDoc) {
                console.log(adfDoc.data());
                 let adf_data = adfDoc.data();
              //   contact_data.uid = contDoc.id;
                 adflist.push(adf_data)
              })
              //console.log(employmentlist);
             // this.contactItem = userlist;
              resolve(adflist)
            })
    })
  }
  getAllOpenform() {
    return new Promise((resolve,reject) => {
      firebase.firestore().collection("adf_forms").where('deleted', '==', 0).where('application_status','==','open').orderBy('created_date', 'desc').limit(10).get()
            .then(function (querySnapshot2) {
              console.log(querySnapshot2);
              let adflist = [];
              querySnapshot2.forEach(function (adfDoc) {
                console.log(adfDoc.data());
                 let adf_data = adfDoc.data();
              //   contact_data.uid = contDoc.id;
                 adflist.push(adf_data)
              })
              //console.log(employmentlist);
             // this.contactItem = userlist;
              resolve(adflist)
            })
    })
  }

  async getAllCloseform() {
    let adflist = [];
    try {
      let totaladf = 0;
      let totalcontacts = 0;
      this.allopenadf = await firebase.firestore().collection("adf_forms").where('deleted', '==', 0).where('application_status','==','open').orderBy('created_date', 'desc').limit(10).get();
      this.allclosedadf = await firebase.firestore().collection("adf_forms").where('deleted', '==', 0).where('application_status','==','closed').orderBy('created_date', 'desc').limit(10).get();
      // let totaladf = await firebase.firestore().collection("adf_forms").where('deleted', '==', 0).get();
      // let totalcontacts = await firebase.firestore().collection("contact_details").where('deleted', '==', 0).get();
      let analytics =  await firebase.firestore().collection("analytics").where('id', '==', 1).get();

      for(const analyticitem of analytics.docs){
        totaladf = analyticitem.data().total_adf;
        totalcontacts = analyticitem.data().total_users;
      }
      let openadf = [];
      for(const opendoc of this.allopenadf.docs){
        openadf.push(opendoc.data());
      }

      let closeadf = [];
      for(const closedoc of this.allclosedadf.docs){
        closeadf.push(closedoc.data());
      }

      const data = {
        allopenadf:openadf,
        allclosedadf:closeadf,
        totaladf:totaladf,
        totalcontacts:totalcontacts
      }
        return data;

    } catch(error) {
      console.log("error", error);
      // appropriately handle the error
    }
      
    
  }

  getallopenApplication() {
    return new Promise((resolve,reject)=>{
 

      // Construct a new query starting at this document,
      // get the next 25 cities.
     
       this.getallopenadflist().then((data)=>{
         console.log(data);
         resolve(data);
       })
    })
  }
  async getallopenadflist() {
     try {

 
        let lastVisible = this.allopenadf.docs[this.allopenadf.docs.length-1];
      console.log("last", lastVisible);

      this.allopenadf  = await firebase.firestore().collection("adf_forms")
      .where('deleted', '==', 0).where('application_status','==','open').orderBy('created_date', 'desc')
      .startAfter(lastVisible)
      .limit(10)
      .get();
      let openadf = [];
      for(const opendoc of this.allopenadf.docs){
        openadf.push(opendoc.data());
      }
      //console.log(this.allopenadf)
      return openadf;
    }
    catch {

    }
  }
  getDashboardData() {
    return new Promise((resolve,reject)=>{
      this.getAllCloseform().then((data)=>{
        resolve(data);
      });
     
    })
  }
  searchContactData() {
    //debugger;
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("users").get()
      .then(function (querySnapshot2) {
        //console.log(querySnapshot2);
        let users = [];
        querySnapshot2.forEach(function (userDoc) {
          //console.log(userDoc.data());
           let user_data = userDoc.data();
        //   contact_data.uid = contDoc.id;
              users.push(user_data)
        })
        resolve(users);
    })
  })
}
getAllAdflist() {
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("adf_forms").get()
    .then(function (querySnapshot2) {
      console.log(querySnapshot2);
      let alladf_forms = [];
      querySnapshot2.forEach(function (userDoc) {
        //console.log(userDoc.data());
         let user_data = userDoc.data();
      //   contact_data.uid = contDoc.id;
      alladf_forms.push(user_data)
      })
      resolve(alladf_forms);
  })
})  
}

searchAllContacts(search) {
  let keyword = search.toLowerCase();
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).where('keywords', 'array-contains', keyword).orderBy('created_date', 'desc').get()
    .then(function (querySnapshot2) {
      console.log(querySnapshot2);
      let userlist = [];
      querySnapshot2.forEach( function (contDoc) {
        //console.log(empDoc.data());
        let contact_data = contDoc.data();
        userlist.push(contact_data)
      })
      resolve(userlist);

    })
}) 
}

searchAllAdfs(search) {
  let keyword = search.toLowerCase();
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("adf_forms").where('deleted', '==', 0).where('keywords', 'array-contains', keyword).orderBy('created_date', 'desc').get()
    .then(function (querySnapshot2) {
      console.log(querySnapshot2);
      let userlist = [];
      querySnapshot2.forEach( function (contDoc) {
        //console.log(empDoc.data());
        let contact_data = contDoc.data();
        userlist.push(contact_data)
      })
      resolve(userlist);

    })
}) 
}

generatekeyword() {
  let thiss = this;
  let email = 'charlescye@gmail.com'
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("users").get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let all_users = [];
          querySnapshot2.forEach(function (userDoc) {
            //console.log(userDoc.data());
            let user_data = userDoc.data();
            let reference_broker = user_data.reference_broker;

            if(reference_broker) {
              firebase.firestore().collection("users").doc(reference_broker).get().then(function (brokersnap) {
                //console.log('abc');
                  user_data.broker_data = brokersnap.data();
                  let keywordNameWithUser = thiss.createKeywords(`${user_data.firstname.toLowerCase()} ${user_data.lastname.toLowerCase()}`);
                  let keywordLastNameWithUser = thiss.createKeywords(`${user_data.lastname.toLowerCase()}`);
                  
                 
                  const keywordNameWithEmail = thiss.createKeywords(`${user_data.email.toLowerCase()}`);
                  //var c = keywordNameWithUser.concat(keywordNameWithEmail);
                 
                  const keywordNameWithPhone = thiss.createKeywords(`${user_data.mobile_phone}`);
                  let keywordNameWithBroker;
                  let keywordLastNameWithBroker;
                  if(user_data.broker_data) {
                     keywordNameWithBroker = thiss.createKeywords(`${user_data.broker_data.firstname.toLowerCase()} ${user_data.broker_data.lastname.toLowerCase()}`);
                     keywordLastNameWithBroker = thiss.createKeywords(`${user_data.broker_data.lastname.toLowerCase()}`);
                  }
                  else {
                    keywordNameWithBroker = []
                    keywordLastNameWithBroker = []
                  }
                  

                  let final_keyword_list = [...keywordNameWithUser,...keywordNameWithEmail,...keywordNameWithPhone,...keywordNameWithBroker,...keywordLastNameWithUser,...keywordLastNameWithBroker];

                  var d = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)
                  // console.log(d);
                  // console.log(final_keyword_list);
                  userDoc.ref.update({ keywords: d });
                  user_data.keyword = d;
                  all_users.push(user_data);
                  resolve(true);
                })
            }
            else {
              user_data.broker_data = '';
              let keywordNameWithUser = thiss.createKeywords(`${user_data.firstname.toLowerCase()} ${user_data.lastname.toLowerCase()}`);
              const keywordLastNameWithUser = thiss.createKeywords(`${user_data.lastname.toLowerCase()}`);

              const keywordNameWithEmail = thiss.createKeywords(`${user_data.email.toLowerCase()}`);
              
              //var c = keywordNameWithUser.concat(keywordNameWithEmail);
             
              const keywordNameWithPhone = thiss.createKeywords(`${user_data.mobile_phone}`);

              let keywordNameWithBroker;
              let keywordLastNameWithBroker;
              if(user_data.broker_data) {
                 keywordNameWithBroker = thiss.createKeywords(`${user_data.broker_data.firstname.toLowerCase()} ${user_data.broker_data.lastname.toLowerCase()}`);
                 keywordLastNameWithBroker = thiss.createKeywords(`${user_data.broker_data.lastname.toLowerCase()}`);
              }
              else {
                keywordNameWithBroker = []
                keywordLastNameWithBroker=[]
              }
    

              let final_keyword_list = [...keywordNameWithUser,...keywordNameWithEmail,...keywordNameWithPhone,...keywordNameWithBroker,...keywordLastNameWithUser,...keywordLastNameWithBroker];

              var d = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)
              // console.log(d);
              // console.log(final_keyword_list);
              userDoc.ref.update({ keywords: d });
              user_data.keyword = d;
              all_users.push(user_data);
              resolve(true);
            }
          //   contact_data.uid = contDoc.id;
          //all_users.push(user_data)
          })
          resolve(all_users);
      })
  })
}

generateAdfkeyword() {
  let thiss = this;
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("adf_forms").get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let all_adfs = [];
          querySnapshot2.forEach(function (adfDoc) {
            //console.log(userDoc.data());
            let adf_data = adfDoc.data();
            let reference_broker = adf_data.reference_broker;

            if(reference_broker) {
              firebase.firestore().collection("users").doc(reference_broker).get().then(function (brokersnap) {
                //console.log('abc');
                  adf_data.broker_data = brokersnap.data();
                  let keywordNameWithBroker;
                  let keywordLastNameWithBroker;
                  if(adf_data.broker_data) {
                    keywordNameWithBroker = thiss.createKeywords(`${adf_data.broker_data.firstname.toLowerCase()} ${adf_data.broker_data.lastname.toLowerCase()}`);
                    keywordLastNameWithBroker = thiss.createKeywords(`${adf_data.broker_data.lastname.toLowerCase()}`);
                 }
                 else {
                   keywordNameWithBroker = []
                   keywordLastNameWithBroker = []
                 }
                 let keywordNameWithUser = [];
                 let keywordLastNameWithUser = [];
                  
                 if(adf_data.contacts.length > 0) {
                  adf_data.contacts.forEach(contactelement => {
                      if(contactelement.type == "primary") {
                        keywordNameWithUser = thiss.createKeywords(`${contactelement.user_data.firstname.toLowerCase()} ${contactelement.user_data.lastname.toLowerCase()}`);
                        keywordLastNameWithUser = thiss.createKeywords(`${contactelement.user_data.lastname.toLowerCase()}`);
                      }
                  });
                 }
                 else {
                  keywordNameWithUser = [];
                  keywordLastNameWithUser = [];
                 }
                  let keywordNameWithStatus;
                  if(adf_data.application_status) {
                     keywordNameWithStatus = thiss.createKeywords(`${adf_data.application_status.toLowerCase()}`);
                  }
                  else {
                     keywordNameWithStatus = [];
                  }
                  
                  let keywordNameWithTitle = thiss.createKeywords(`${adf_data.title.toLowerCase()}`);
                  let keywordNameWithDate;
                  if(adf_data.created_date) {
                    let d = new Date(adf_data.created_date);
                    let dateobj = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();
  
                     keywordNameWithDate = thiss.createKeywords(`${dateobj}`);
                  }
                  else {
                    keywordNameWithDate = [];
                  }
                  

                  let final_keyword_list = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate,...keywordLastNameWithUser,...keywordLastNameWithBroker];

                  var filterdata = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)


                  adfDoc.ref.update({ keywords: filterdata });
                  adf_data.keyword = filterdata;
                  all_adfs.push(adf_data);
                  resolve(true);
                
                })
            }
            else {
              adf_data.broker_data = '';
              let keywordNameWithBroker;
              let keywordLastNameWithBroker;
                  if(adf_data.broker_data) {
                    keywordNameWithBroker = thiss.createKeywords(`${adf_data.broker_data.firstname.toLowerCase()} ${adf_data.broker_data.lastname.toLowerCase()}`);
                    keywordLastNameWithBroker = thiss.createKeywords(`${adf_data.broker_data.lastname.toLowerCase()}`);
                 }
                 else {
                   keywordNameWithBroker = []
                   keywordLastNameWithBroker=[]
                 }
                 let keywordNameWithUser = [];
                 let keywordLastNameWithUser = [];
                 if(adf_data.contacts.length > 0) {
                  adf_data.contacts.forEach(contactelement => {
                      if(contactelement.type == "primary") {
                        keywordNameWithUser = thiss.createKeywords(`${contactelement.user_data.firstname.toLowerCase()} ${contactelement.user_data.lastname.toLowerCase()}`);
                        keywordLastNameWithUser = thiss.createKeywords(`${contactelement.user_data.lastname.toLowerCase()}`);
                      }
                  });
                 }
                 else {
                  keywordNameWithUser = [];
                  keywordLastNameWithUser = [];
                 }
                  let keywordNameWithStatus;
                  if(adf_data.application_status) {
                     keywordNameWithStatus = thiss.createKeywords(`${adf_data.application_status.toLowerCase()}`);
                  }
                  else {
                     keywordNameWithStatus = [];
                  }
                  let keywordNameWithTitle;
                  if(adf_data.title) {
                     keywordNameWithTitle = thiss.createKeywords(`${adf_data.title.toLowerCase()}`);
                  }
                  else {
                    keywordNameWithTitle = [];
                  }
                  
                  let keywordNameWithDate;
                  if(adf_data.created_date) {
                    let d = new Date(adf_data.created_date);
                    let dateobj = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();
                    console.log(dateobj);
                     keywordNameWithDate = thiss.createKeywords(`${dateobj}`);
                  }
                  else {
                    keywordNameWithDate = [];
                  }
                  

                  let final_keyword_list = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate,...keywordLastNameWithBroker,...keywordLastNameWithUser];

                  var filterdata = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)


                  adfDoc.ref.update({ keywords: filterdata });
                  adf_data.keyword = filterdata;
                  all_adfs.push(adf_data);
                  resolve(true);
             
            }
          //   contact_data.uid = contDoc.id;
          //all_users.push(user_data)
          })
          resolve(all_adfs);
      })
  })
}

  createKeywords = name => {
    const arrName = [];
    let curName = '';
    name.split('').forEach(letter => {
      curName += letter;
      arrName.push(curName);
    });
    return arrName;
  }
  // searchContactData(searchKey) {
  //   //debugger;
  //   return new Promise((resolve,reject)=>{
  //     firebase.firestore().collection("users").where('firstname', '>=', searchKey).where('firstname', '<=', searchKey).get()
  //     .then(function (querySnapshot2) {
  //       console.log(querySnapshot2);
  //       let users = [];
  //       let flag = 0;
  //       querySnapshot2.forEach(function (userDoc) {
  //         console.log(userDoc.data());
  //          let user_data = userDoc.data();
  //          flag = 1;
  //       //   contact_data.uid = contDoc.id;
  //             users.push(user_data)
  //       })
  //       if(users.length > 0) {
  //         resolve(users)
  //       }
        

  //       if(flag == 0) {
  //         firebase.firestore().collection("users").where('lastname', '>=', searchKey).where('lastname', '<=', searchKey).get()
  //         .then(function (querySnapshot3) {

  //           querySnapshot3.forEach(function (userDoc) {
  //             console.log(userDoc.data());
  //              let user_data = userDoc.data();
  //              flag = 1;
  //           //   contact_data.uid = contDoc.id;
  //                 users.push(user_data)
  //           })
  //           if(users.length > 0) {
  //             resolve(users)
  //           }
  //           if(flag == 0) {
  //             firebase.firestore().collection("users").where('email', '>=', searchKey).where('email', '<=', searchKey).get()
  //             .then(function (querySnapshot3) {
  //             querySnapshot3.forEach(function (userDoc) {
  //               console.log(userDoc.data());
  //                let user_data = userDoc.data();
  //                flag = 1;
  //             //   contact_data.uid = contDoc.id;
  //                   users.push(user_data)
  //               })
  //           } )
  //           }
  //         })
  //       }
  //       //console.log(employmentlist);
  //      // this.contactItem = userlist;
        
  //     })
  //   })
 // }

 gekeywordsemptyData() {
   return new Promise((resolve,reject)=>{
    firebase.firestore().collection("users").where('keywords','==',null).get() 
                .then(function (querySnapshot3) {
                  let users = [];

                  querySnapshot3.forEach(function (userDoc) {
                    console.log(userDoc.data());
                      users.push(userDoc.data());
                    })
                })
   })
 }

 saveActiveStatus(active_data) {
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("active_deals").where('group','==',active_data.group).get() 
                .then(function (querySnapshot3) {
                  let flag = 0;
                  querySnapshot3.forEach(function (activeDoc) {
                      flag = 1;
                      activeDoc.ref.update(active_data);
                      let data = {
                        status:'success',
                        data:activeDoc.data()
                      }
                      
                      resolve(data);
                    })

                    if(flag == 0) {
                      firebase.firestore().collection("active_deals").add(active_data).then(function(activeDoc){
                          
                        let data = {
                          status:'success',
                          data:active_data
                        }
                        
                        resolve(data);
                      }) 
                    }

                   
                })
   })
 }

 getActiveStatus() {
   return new Promise((resolve,reject)=>{
     let active_data = [];
    firebase.firestore().collection("active_deals").get() 
    .then(function (querySnapshot3) {
      let flag = 0;
      querySnapshot3.forEach(function (activeDoc) {
          flag = 1;
          let data = activeDoc.data();
          active_data.push(data);
        })
       resolve(active_data);
    })
   })
 }
  
 saveACFiles(ac_data) {
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("active_files")
      .add(ac_data)
      .then(function (querySnapshot3) {
         resolve(true);
      })
    })
 }
 deleteACFiles(downloadUrl) {
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("active_files")
    .where('ac_downlink','==',downloadUrl)
    .get()
    .then(function (querySnapshot1) {
      querySnapshot1.forEach(function(doc) {
        doc.ref.delete();
      });
      resolve(true);
    })
  })
 }
 getAllACfiles(ac_contact_id,ac_deal_id) {
   debugger;
   let acfiles = [];
   return new Promise((resolve,reject)=>{
    firebase.firestore().collection("active_files")
    .where('ac_contact_id','==',ac_contact_id)
    .where('ac_deal_id','==',ac_deal_id)
    .get()
    .then(function (querySnapshot1) {
      querySnapshot1.forEach(function(doc) {
        let acobj = doc.data();
        acfiles.push(acobj);
      });
      resolve(acfiles);
    })
   })
 }
 

}


// WEBPACK FOOTER //
// ./src/pages/adf-page/services/adf-list.service.ts